import React, { useState } from "react";
import "./HeaderPublic.css";

// The admongrel.com site header (its /components/header.html), with the
// links pointing at the site.
export default function HeaderPublic() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo Section */}
          <div className="logo">
            <a href="/login">
              <img src="/logo-admongrel.png" width="266" alt="AdMongrel" className="logo-image" />
            </a>
          </div>

          {/* Navigation */}
          <nav className={`navigation${menuOpen ? " nav-open" : ""}`}>
            <ul className="nav-list">
              <li className="nav-item">
                <a href="https://admongrel.com/about" className="nav-link">About Us</a>
              </li>
              <li className="nav-item">
                <a href="https://admongrel.com/solutions" className="nav-link">Our Solutions</a>
              </li>
              <li className="nav-item">
                <a href="https://admongrel.com/blog-list" className="nav-link">Blog</a>
              </li>
              <li className="nav-item">
                <a href="https://admongrel.com/contact" className="nav-link">Contact Us</a>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            className={`mobile-menu-toggle${menuOpen ? " menu-open" : ""}`}
            aria-label="Toggle mobile menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </div>
    </header>
  );
}
